import { ScrollTrigger } from '../global/gsap';

const initScrollDirection = () => {
    const topThreshold = 200;
    const bottomThreshold = 20;
    let scrollTimeout;

    const st = ScrollTrigger.create({
        start: 0,
        end: "max",
        onUpdate: (self) => {
            const currentScroll = self.scroll();

            // 1. "Is Scrolling" state
            document.body.setAttribute('data-is-scrolling', 'true');
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                document.body.setAttribute('data-is-scrolling', 'false');
            }, 250);

            // 2. Direction & Scrolled Threshold
            if (currentScroll > topThreshold) {
                document.body.setAttribute('data-scroll-direction', self.direction === 1 ? 'down' : 'up');
                document.body.setAttribute('data-scrolled', 'true');
            } else {
                document.body.setAttribute('data-scroll-direction', 'top');
                document.body.setAttribute('data-scrolled', 'false');
            }

            // 3. Precise Bottom Detection
            // We use self.end to get the current maximum scrollable distance
            const isAtBottom = currentScroll >= (self.end - bottomThreshold);
            document.body.setAttribute('data-at-bottom', isAtBottom ? 'true' : 'false');
        }
    });
};

export { initScrollDirection as default };
